// extracted by mini-css-extract-plugin
module.exports = {"description":"MilestoneDescription-module--description--hjUqc","done":"MilestoneDescription-module--done--29x2D"};